import React, { useEffect, useMemo, useState } from 'react';
import useDataLoader2 from '../../hooks/useDataLoader2';
import CatalogTableC from '../../components/Catalogs/CatalogTableC';
import PaginatedTable from '../../components/Organismos/Table/PaginatedTable';
import ShapeEdit from '../../components/Atomos/Icons/ShapeEdit';
import { formatTimeSpanToString } from '../../utils/functions';
import { useStatesList } from '../../hooks/Catalogs/useStates';
import { UseCountryList } from '../../hooks/Catalogs';
import { ISubstate } from '../../interfaces';
import { defaultPageSize } from '../../utils/const';
import Filters, { IFilterData } from '../../components/Catalogs/Filters/Filters';
import PersistentLink from '../../components/Moleculas/PersistentLink';
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const State: React.FC = ({ ...props }) => {
  const [stateByCountryData, setStateByCountryData] = useState<any[]>([]);
  const fields = [
    'id', 
    'name',
    'abbreviation',
    'state',
    'stateName',
    'countryName',
    'createdDate'
  ]
  const endpoint = '/substate';
  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    inputFilters,
    setInputFilters,
    filter
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });
  const { statesData } = useStatesList()
  const { countryData} = UseCountryList()
  const columnsDef = useMemo(() => [
    { 
      id: 'count', 
      header: '#', 
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>{rowIndex + 1 + pagination.pageIndex * pagination.pageSize}</p>
      )
    },
    { id: 'name', header: 'Name' },
    { id: 'abbreviation', header: 'Abbreviation' },
    { id: 'state', header: 'State' },
    { id: 'country', header: 'Country' },
    { id: 'createdDate', header: 'Created Date' },
    {
      id: 'edit', 
      header: 'Edit', 
      enableSorting: false,
      cell: ({ row, rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={data[rowIndex]}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit
          <div className="editsvg"><ShapeEdit /></div>
        </PersistentLink>
      )
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters, data]);

  const formatData = (data: ISubstate[]) => {
    const formatedData = data.map(d => {
      return {
        ...d,
        state: d.stateName,
        country: d.countryName,
        createdDate: d.createdDate ? formatTimeSpanToString(d.createdDate) : '',
      }
    })
    return formatedData
  }

  useEffect(() => {
    const states = statesData.filter(s => filter?.country?.value?.includes(s.country))
    setStateByCountryData(states)
  },[filter?.country]);

  const filtersData: IFilterData[] = useMemo(() => [
    {
      name: "Name",
      type: "text",
      comparison: "CONTAINS",
    },
    {
      name: "Abbreviation",
      type: "text",
      comparison: "CONTAINS",
    },
    {
      name: "Country", 
      objectData: countryData?.map(c => ({id: c.id, name: c.name})) || [],
    },
    {
      name: "State",
      objectData: stateByCountryData || [],
      disabled: !stateByCountryData?.length
    },
  ], [countryData, stateByCountryData]);
  
  return (
    <>
      <div>
        <CatalogTableC
          title={`SubState Catalog`}
          catalogName={'SUBSTATES'}
          catalogShortName='SUBSTATE'
          route={'SubState'}
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />
        </CatalogTableC>
      </div>
    </>
  );
};

export default State;
